Ext.define('SA.ArrowExportMenu', {
    alias: 'widget.arrow-export-menu',
    extend: 'SA.view.ArrowMenu',

    alignment: 'bottom',
    autoShow: true,
    behaveAsWindow: true,
    closeAction: 'hide',
    cls: 'sa-arrow-export-menu',
    ignoreTargetMouseDown: true,

    initComponent() {
        this.items = [{xtype: 'export-widget', config: this.config}];
        this.target = this.toolbarButton;

        this.callParent();

        this.exportWidget = this.down('export-widget');
    },

    beforeDestroy() {
        this.callParent();

        this.toolbarButton.setInactive();
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.syncPosition, this);
        this.mon(this.toolbarButton, 'click', this.destroy, this);

        this.on('beforehide', this.onBeforeHide, this);
        this.on('hide', this.destroy, this);

        this.exportWidget.on('click:cancel', this.destroy, this);
        this.exportWidget.on('click:export', this.destroy, this);
    },

    onBeforeHide() {
        return this.config.canHideWindow();
    }
});